import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function Profile() {
  const { id, npp } = useParams();
  const history = useHistory();
  const ADMIN = 1;
  const ANGGOTA = 2;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  
  const [empData, setEmpData] = useState([]);
  const [newData, setNewData] = useState({
    nama: null,
    nohp: null,
    alamat: null,
    email: null,
    no_rekening: null,
    nama_bank: null,
    atas_nama: null
  })


  // CONTROLLER
  const fetchUserData = async (id) => {
    setIsLoading(true);
    await baseAPI 
      .get(`/v1/user/${id}`, {
         headers: { Authorization: `Bearer ${token}` } 
      })
      .then((res) => {
        const data = res.data.data.userData;       
        setEmpData(data[0]);
        setNewData({...newData, 
          nama: data[0].name_anggota, 
          email: data[0].email, 
          nohp: data[0].no_hp, 
          alamat: data[0].alamat,
          no_rekening: data[0].no_rekening,
          nama_bank: data[0].nama_bank,
          atas_nama: data[0].atas_nama,
        })
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const updateProfile = async (id) => {
    Swal.fire({
      title: 'Do you want to update your profile?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Update',
      denyButtonText: `Don't update`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('update_data', JSON.stringify(newData));

        baseAPI
          .put(`/v1/profile/${id}`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Your profile has been updated.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil update ${JSON.stringify(res)}`);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Failed update your profile.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchUserData(id);
          })
      } else if (result.isDenied) {
        Swal.fire('Data is not updated', '', 'info')
      }
    });
  }

  useEffect(() => {
      fetchUserData(user.id);
  }, [token]);

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='/auth/profile' style={{ color: '#333' }}>Profile</Link>
            </li>
          </ol>
        </div>

        {/* Reset Password */}
          <div className='col-auto ml-auto d-print-none'>
            <Link to="/auth/resetpassword">
              <button
                type="button"
                className="btn btn-gray"
                style={{ marginLeft: 10 }}
                onClick={() => console.log('reset password')}
              >
                <div className="d-flex align-items-center">
                  <Icon name="Edit" size={16} style={{ marginRight: 5 }} />{' '}
                  <span>Reset Password</span>
                </div>
              </button>
            </Link>
          </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div>
                <p style={{fontSize: 25}}><b>Profile</b></p>
                <p>Jangan lupa klik "Save" jika telah melakukan perubahan.</p>
              </div>
              
              {/* Name */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Nama
                </label>
                <input
                  defaultValue={empData.name_anggota}
                  placeholder='Nama anda'
                  className="form-control"
                  onChange={e => setNewData({...newData, nama: e.target.value})}
                />
              </div>

              {/* No handphone */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  No Handphone
                </label>
                <input
                  defaultValue={empData.no_hp}
                  placeholder='No handphone, exp: 0812xxx'
                  className="form-control"
                  onChange={e => setNewData({...newData, nohp: e.target.value})}
                />
              </div>

              {/* Alamat */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Alamat
                </label>
                <input
                  defaultValue={empData.alamat}
                  placeholder='Alamat'
                  className="form-control"
                  onChange={e => setNewData({...newData, alamat: e.target.value})}
                />
              </div>

              {/* Email */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Email
                </label>
                <input
                  defaultValue={empData.email}
                  placeholder='Email'
                  className="form-control"
                  onChange={e => setNewData({...newData, email: e.target.value})}
                />
              </div>

              {/* No Rekening */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  No Rekening
                </label>
                <input
                  defaultValue={empData.no_rekening}
                  placeholder='No rekening'
                  className="form-control"
                  onChange={e => setNewData({...newData, no_rekening: e.target.value})}
                />
              </div>

              {/* Nama Bank */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Nama Bank
                </label>
                <input
                  defaultValue={empData.nama_bank}
                  placeholder='Nama bank'
                  className="form-control"
                  onChange={e => setNewData({...newData, nama_bank: e.target.value})}
                />
              </div>

              {/* Atas Nama Rekening */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Atas Nama Rekening
                </label>
                <input
                  defaultValue={empData.atas_nama}
                  placeholder='Atas nama rekening'
                  className="form-control"
                  onChange={e => setNewData({...newData, atas_nama: e.target.value})}
                />
              </div>

              <div className='col-md-12'>
                <button
                  disabled={newData.nama !== null && newData.nohp !== null && newData.alamat !== null && newData.email !== null && newData.no_rekening !== null && newData.nama_bank !== null && newData.atas_nama !== null ? false : true}
                  type="button"
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: '#CD5C08'}}
                  onClick={() => updateProfile(user.id)}
                >
                  Save
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default Profile;